import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Common from "../../Components/Layouts/Common";
import { usePermission } from "../../Context Api/PermissionContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ItemCard = ({
  mainText,
  subText,
  icon,
  href,
  handler,
  requiredPermission,
  disabled = false,
}) => {
  const { hasPermission, loading } = usePermission();

  if (loading) {
    return null; // Or you could return a loading indicator
  }

  if (!hasPermission(requiredPermission)) {
    return null;
  }

  return (
    <Link
      to={href}
      className={`flex flex-col items-center ${
        disabled ? "cursor-not-allowed" : ""
      }`}
    >
      <div
        onClick={handler}
        className="w-24 h-24 bg-gray-100 rounded-full shadow-lg mb-4 flex justify-center items-center"
      >
        <FontAwesomeIcon
          icon={icon}
          className={`${icon} text-2xl text-gray-600 ${
            disabled ? "opacity-50" : ""
          }`}
        />
      </div>
      <h3
        className={`text-gray-800 font-semibold text-lg ${
          disabled ? "text-opacity-45" : ""
        }`}
      >
        {mainText}
      </h3>
      <p
        className={`text-gray-500 text-sm ${disabled ? "text-opacity-45" : ""}`}
      >
        {subText}
      </p>
    </Link>
  );
};

//requiredPermission="Super Admin"  Survey Kii IMIS Data Insertion"|| "IMIS Data Publication
const Dashboard = () => {
  const { t } = useTranslation();
  const { loading } = usePermission();

  if (loading) {
    return <div>Loading permissions...</div>;
  }

  return (
    <Common headline={t("dashboard.Modules")}>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 text-center gap-6">
        <ItemCard
          mainText={t("dashboard.user_management")}
          subText="Manage Users"
          icon={"fa-solid fa-users"}
          href={"/manage-users"}
          requiredPermission={"Super Admin"}
          //requiredPermission="User_Management"
        />
        <ItemCard
          mainText={t("dashboard.project_management")}
          subText="Manage Projects"
          icon={"fa-solid fa-diagram-project"}
          href={"/projects"}
          requiredPermission={"Survey"}
          //requiredPermission="User_Management"
        />
        <ItemCard
          mainText={t("dashboard.kii_management")}
          subText="Manage KII"
          icon={"fa-solid fa-square-poll-vertical"}
          href={"/manage-kii"}
          requiredPermission={"Kii"}
          //requiredPermission="KII_Management"
        />
        <ItemCard
          mainText={t("dashboard.survey_management")}
          subText="Manage Survey"
          icon={"fa-solid fa-rectangle-list"}
          href={"/manage-survey"}
          requiredPermission={"Survey"}
          //requiredPermission="Survey_Management"
        />
        <ItemCard
          mainText={t("dashboard.survey_questionnaire")}
          subText="Manage Survey Questionnaire"
          icon={"fa-solid fa-chart-bar"}
          href={"/survey-questionnaire"}
          requiredPermission={"Survey"}
          //requiredPermission="Survey_Questionnaire_Management"
        />
        <ItemCard
          mainText={t("dashboard.kii_questionnaire")}
          subText="Manage KII Questionnaire"
          icon={"fa-solid fa-clipboard-question"}
          href={"/kii-questionnaire"}
          requiredPermission={"Kii"}
          //requiredPermission="KII_Questionnaire_Management"
        />

        <ItemCard
          mainText={"IMIS Data Insertion"}
          subText="View Inserted Data"
          icon={"fa-solid fa-diagram-project"}
          href={"/data-insertion"}
          requiredPermission={"IMIS Data Insertion"}
        />
        <ItemCard
          mainText={t("dashboard.imis_data_management")}
          subText="Manage Data"
          icon={"fa-solid fa-gauge"}
          href={"/imis-dashboard"}
          requiredPermission={"IMIS Data Publication"}
        />

        <ItemCard
          mainText={t("dashboard.city_profile_data_insertion")}
          subText="City Profile Basic Data Insertion"
          icon={"fa-solid fa-database"}
          href={"/manage-cityprofile-data"}
          requiredPermission={"Survey"}
        />
        {/* 
        <ItemCard
          mainText={"IMIS User Management"}
          subText="Manage User"
          icon={"fa-solid fa-users"}
          href={""}
          requiredPermission={"IMIS Data Publication"}
          disabled={true}
        /> */}
      </div>
    </Common>
  );
};

export default Dashboard;
